import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class SalePoDetailsInfo {
  @ApiProperty()

  SoPoId: number;
  @ApiProperty()

  saleOrderId?: number;
  @ApiProperty()

  // soakingTime:string;
  // @ApiProperty()

  // // hLFinalProduct:string;
  // @ApiProperty()

  // glazzing:number;
  // @ApiProperty()

  additionalNote: string;
  @ApiProperty()

  // styleWeighmentId:string;
  // @ApiProperty()

  // sockingStyleId:string;
  // @ApiProperty()

  certificationId: number;
  @ApiProperty()

  isBrandApproved: string;
  @ApiProperty()
  brandDesignType: string;
  @ApiProperty()
  iscertification: string;
  @ApiProperty()
  rating: number;
  @ApiProperty()
  labInspection:string;
  @ApiProperty()
  loadInspection:boolean;





  /**
  * @param SoPoId
  * @param sale_order_id
  * @param soakingTime
  * @param hl_final_product
  * @param glazzing
  * @param additionalNote
  * @param styleWeighmentId
  * @param sockingStyleId
  * @param certificationId
  * @param iscertification
  * @param rating
  * @param labInspection
  * @param loadInspection
   */
  constructor(SoPoId: number, sale_order_id: number, soakingTime: string, hl_final_product: string, glazzing: number, additionalNote: string, styleWeighmentId: string, sockingStyleId: string, certificationId: number, createdUser: string, rating: number, iscertification: string,labInspection: string,loadInspection: boolean) {
    this.SoPoId = SoPoId;
    this.saleOrderId = sale_order_id;
    // this.soakingTime = soakingTime;
    // this.hl_final_product = hl_final_product;
    // this.glazzing = glazzing;
    this.additionalNote = additionalNote;
    // this.styleWeighmentId = styleWeighmentId;
    // this.sockingStyleId = sockingStyleId;
    this.certificationId = certificationId;
    this.rating = rating;
    this.iscertification = iscertification;
    this.labInspection = labInspection;
    this.loadInspection = loadInspection;

  }
}


